import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { PropsWithChildren } from "react";

import { usePaintConfiguratorContext } from "@/components/PaintConfigurator/context/paintConfigurator.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type HeaderProps = {
    subTitle: string;
};

const Header = ({ subTitle, children }: PropsWithChildren<HeaderProps>) => {
    const { t } = useGranite();
    const { currentStep, previousStep, canGoBack } =
        usePaintConfiguratorContext();

    if (!currentStep) return null;

    return (
        <div>
            <p className={cn("tw:text-2xl tw:mb-3")}>
                {t("paintConfigurator.step.label")} {currentStep.index + 1} -{" "}
                {currentStep.meta.name}
            </p>
            <p>{subTitle}</p>
            {canGoBack && (
                <p>
                    <Button
                        color="link"
                        onClick={previousStep}
                        className={cn("tw:p-0")}
                    >
                        <span className={cn("las la-angle-left")}></span>
                        {t("paintConfigurator.navigation.previous")}
                    </Button>
                </p>
            )}
            {children}
        </div>
    );
};

export { Header };
